const {concat, head, join, map, pipe, split, tail, toLower, toUpper} = require('ramda')

const upperFirst = pipe(toUpper, head)
const lowerLast = pipe(tail, toLower)

const cap = str => concat(upperFirst(str), lowerLast(str))

module.exports = pipe(
  split(' '),
  map(cap),
  join(' ')
)
